import { dom, library } from '@fortawesome/fontawesome-svg-core';

import {
    faPlateUtensils as falPlateUtensils,
    faCardsBlank as falCardsBlank,
    faArrowUpFromBracket as falArrowUpFromBracket,
    faUserGroup as falUserGroup,
    faDoorOpen as falDoorOpen,
    faImages as falImages,
    faVial as falVial,
    faSort as falSort,
    faShield as falShield,
    faArrowLeft as falArrowLeft,
    faGrid2 as falGrid2,
    faAtlas as falAtlas,
    faBan as falBan,
    faBed as falBed,
    faShower as falShower,
    faToilet as falToilet,
    faBath as falBath,
    faBell as falBell,
    faBuilding as falBuilding,
    faCameraAlt as falCameraAlt,
    faCampfire as falCampfire,
    faCheck as falCheck,
    faChevronCircleLeft as falChevronCircleLeft,
    faChevronCircleRight as falChevronCircleRight,
    faChevronLeft as falChevronLeft,
    faChevronRight as falChevronRight,
    faCircle as falCircle,
    faCircleCheck as falCircleCheck,
    faClock as falClock,
    faCoins as falCoins,
    faCopy as falCopy,
    faEnvelope as falEnvelope,
    faExclamationTriangle as falExclamationTriangle,
    faEye as falEye,
    faEyeSlash as falEyeSlash,
    faFileAlt as falFileAlt,
    faFilter as falFilter,
    faGift as falGift,
    faHandHoldingDollar as falHandHoldingDollar,
    faHandHoldingHeart as falHandHoldingHeart,
    faHeart as falHeart,
    faHomeAlt as falHomeAlt,
    faHotTub as falHotTub,
    faHouseFlag as falHouseFlag,
    faInfoCircle as falInfoCircle,
    faKey as falKey,
    faLanguage as falLanguage,
    faList as falList,
    faLock as falLock,
    faMapLocationDot as falMapLocationDot,
    faMapMarkerAlt as falMapMarkerAlt,
    faMedal as falMedal,
    faMinus as falMinus,
    faMobile as falMobile,
    faMobileAndroidAlt as falMobileAndroidAlt,
    faMoneyBillWave as falMoneyBillWave,
    faMoon as falMoon,
    faPaperPlane as falPaperPlane,
    faParking as falParking,
    faPaw as falPaw,
    faPen as falPen,
    faPhone as falPhone,
    faPhotoVideo as falPhotoVideo,
    faPiggyBank as falPiggyBank,
    faPlane as falPlane,
    faPlus as falPlus,
    faPresentation as falPresentation,
    faScroll as falScroll,
    faSearch as falSearch,
    faShareAlt as falShareAlt,
    faShieldCheck as falShieldCheck,
    faShoppingCart as falShoppingCart,
    faSignInAlt as falSignInAlt,
    faSignOutAlt as falSignOutAlt,
    faSortNumericDown as falSortNumericDown,
    faStar as falStar,
    faStore as falStore,
    faSwimmingPool as falSwimmingPool,
    faSunglasses as falSunglasses,
    faTag as falTag,
    faTimes as falTimes,
    faTimesCircle as falTimesCircle,
    faUser as falUser,
    faUserCircle as falUserCircle,
    faUserClock as falUserClock,
    faUserPlus as falUserPlus,
    faUsers as falUsers,
    faWheelchair as falWheelchair,
    faWifi as falWifi,
    faArrowRight as falArrowRight,
    faArrowRightFromBracket as falArrowRightFromBracket,
    faArrowUpLong as falArrowUpLong,
    faLongArrowDown as falLongArrowDown,
    faAt as falAt,
    faBadgeCheck as falBadgeCheck,
    faBars as falBars,
    faBarsFilter as falBarsFilter,
    faBedFront as falBedFront,
    faBellOn as falBellOn,
    faBookSparkles as falBookSparkles,
    faCamera as falCamera,
    faChevronDown as falChevronDown,
    faChildren as falChildren,
    faBaby as falBaby,
    faCoinBlank as falCoinBlank,
    faCouch as falCouch,
    faCreditCardFront as falCreditCardFront,
    faExternalLink as falExternalLink,
    faFaceSmilingHands as falFaceSmilingHands,
    faGlasses as falGlasses,
    faHandWave as falHandWave,
    faHashtag as falHashtag,
    faHouse as falHouse,
    faHouseChimneyHeart as falHouseChimneyHeart,
    faIdCard as falIdCard,
    faLocationDot as falLocationDot,
    faLocationSmile as falLocationSmile,
    faMap as falMap,
    faMapPin as falMapPin,
    faMegaphone as falMegaphone,
    faMessageDots as falMessageDots,
    faMessageSlash as falMessageSlash,
    faMessageCheck as falMessageCheck,
    faMessageSms as falMessageSms,
    faMountains as falMountains,
    faNotes as falNotes,
    faPencil as falPencil,
    faPeople as falPeople,
    faChild as falChild,
    faQuestionCircle as falQuestionCircle,
    faRoute as falRoute,
    faShare as falShare,
    faSparkles as falSparkles,
    faSprayCanSparkles as falSprayCanSparkles,
    faThumbsUp as falThumbsUp,
    faTrash as falTrash,
    faUserFriends as falUserFriends,
    faUserShield as falUserShield,
    faXmark as falXmark,
    faArrowRightToBracket as falArrowRightToBracket,
    faBellSlash as falBellSlash,
    faPaperPlaneTop as falPaperPlaneTop,
    faAirConditioner as falAirConditioner,
    faGrapes as falGrapes,
    faBroom as falBroom,
    faBinoculars as falBinoculars,
    faVanShuttle as falVanShuttle,
    faBellConcierge as falBellConcierge,
    faHandHoldingHand as falHandHoldingHand,
    faSpa as falSpa,
    faDumbbell as falDumbbell,
    faMessageExclamation as falMessageExclamation,
    faHouseCircleXmark as falHouseCircleXmark,
    faHeartCircle as falHeartCircle,
    faHandHeart as falHandHeart,
    faMapMarkerQuestion as falMapMarkerQuestion,
    faHandshakeAlt as falHandshakeAlt,
    faCalendarAlt as falCalendarAlt,
    faCommentAltCheck as falCommentAltCheck,
    faCarSide as falCarSide,
    faCalendarStar as falCalendarStar,
    faCalendarXmark as falCalendarXmark,
    faCalendarWeek as falCalendarWeek,
    faCalendarPen as falCalendarPen,
    faTrophyStar as falTrophyStar,
    faTrophy as falTrophy,
    faComment as falComment,
    faHouseHeart as falHouseHeart,
    faBookmark as falBookmark,
    faImagePolaroid as falImagePolaroid,
    faLeftLong as falLeftLong,
    faAward as falAward,
    faGiftCard as falGiftCard,
    faCompass as falCompass,
    faPaperclip as falPaperclip,
    faCircleExclamation as falCircleExclamation,
    faCog as falCog,
    faFire as faFire,
    faBookHeart as falBookHeart,
    faRadio as falRadio,
    faCar as faCar,
    faArrowDown91 as falArrowDown91,
    faCommentDots as falCommentDots,
    faCalendarMinus as falCalendarMinus,
    faSlash as falSlash,
    faArrowDownArrowUp as falArrowDownArrowUp,
    faPersonSwimming as falPersonSwimming,
    faCards as falCards,
    faWineGlass as falWineGlass,
    faMartiniGlassCitrus as falMartiniGlassCitrus,
    faElevator as falElevator,
    faUniversalAccess as falUniversalAccess,
    faSliders as falSliders,
    faArrowUpRight as falArrowUpRight,
    faGlobeAfrica as falGlobeAfrica,
    faBlanket as falBlanket,
    faKitchenSet as falKitchenSet,
    faCalendarCheck as falCalendarCheck,
    faCreditCard as falCreditCard,
    faCameraViewfinder as falCameraViewfinder,
    faLink as falLink,
    faCirclePhoneFlip as falCirclePhoneFlip,
    faTags as falTags,
    faFamily as falFamily,
    faChevronUp as falChevronUp,
    faEggFried as falEggFried,
    faLocationCheck as falLocationCheck,
} from '@fortawesome/pro-light-svg-icons';

import {
    faUsers as fasUsers,
    faCalendarHeart as fasCalendarHeart,
    faMapLocationDot as fasMapLocationDot,
    faUserClock as fasUserClock,
    faMoon as fasMoon,
    faPeople as fasPeople,
    faAsterisk as fasAsterisk,
    faBars as fasBars,
    faBed as fasBed,
    faCalendarWeek as fasCalendarWeek,
    faCameraRetro as fasCameraRetro,
    faCheck as fasCheck,
    faChevronDown as fasChevronDown,
    faChevronLeft as fasChevronLeft,
    faChevronRight as fasChevronRight,
    faChevronUp as fasChevronUp,
    faCircle as fasCircle,
    faCircleInfo as fasCircleInfo,
    faCircleUser as fasCircleUser,
    faHeart as fasHeart,
    faHomeLg as fasHomeLg,
    faLock as fasLock,
    faMapMarkerAlt as fasMapMarkerAlt,
    faPaperPlane as fasPaperPlane,
    faPlusSquare as fasPlusSquare,
    faQuoteLeft as fasQuoteLeft,
    faRepeat as fasRepeat,
    faSearch as fasSearch,
    faSignInAlt as fasSignInAlt,
    faStar as fasStar,
    faStarHalfAlt as fasStarHalfAlt,
    faTag as fasTag,
    faThumbsUp as fasThumbsUp,
    faTimes as fasTimes,
    faUserCircle as fasUserCircle,
    faBadgeCheck as fasBadgeCheck,
    faShield as fasShield,
    faPhone as fasPhone,
    faPlus as fasPlus,
    faMinus as fasMinus,
    faCreditCard as fasCreditCard,
    faBolt as fasBolt,
    faCircleCheck as fasCircleCheck,
    faCircleX as fasCircleX,
    faMessageDots as fasMessageDots,
} from '@fortawesome/pro-solid-svg-icons';


import {
    faArrowLeft as farArrowLeft,
    faLocationSmile as farLocationSmile,
    faArrowRight as farArrowRight,
    faArrowUpRightFromSquare as farArrowUpRightFromSquare,
    faAward as farAward,
    faBell as farBell,
    faCalendarWeek as farCalendarWeek,
    faCamera as farCamera,
    faChevronUp as farChevronUp,
    faEllipsisH as farEllipsisH,
    faFireFlameCurved as farFireFlameCurved,
    faGlasses as farGlasses,
    faHandHeart as farHandHeart,
    faHeart as farHeart,
    faHouse as farHouse,
    faHouseChimneyHeart as farHouseChimneyHeart,
    faImages as farImages,
    faInfoCircle as farInfoCircle,
    faList as farList,
    faLocationDot as farLocationDot,
    faLockAlt as farLockAlt,
    faLockOpenAlt as farLockOpenAlt,
    faMap as farMap,
    faMapLocationDot as farMapLocationDot,
    faMegaphone as farMegaphone,
    faMessageDots as farMessageDots,
    faMobile as farMobile,
    faNewspaper as farNewspaper,
    faPlus as farPlus,
    faSearch as farSearch,
    faShare as farShare,
    faSpinnerThird as farSpinnerThird,
    faTag as farTag,
    faTrashCan as farTrashCan,
    faTrophyStar as farTrophyStar,
    faUser as farUser,
    faChevronDown as farChevronDown,
    faVideo as farVideo,
    faXmark as farXmark,
    faUserPlus as farUserPlus,
    faTimes as farTimes,
    faClockRotateLeft as farClockRotateLeft,
    faThumbtack as farThumbtack,
    faCameraRetro as farCameraRetro,
    faMessageImage as farMessageImage,
    faCalendarAlt as farCalendarAlt,
    faCompass as farCompass,
    faBolt as farBolt,
    faMapPin as farMapPin,
    faEraser as farEraser,
    faConciergeBell as farConciergeBell,
    faCreditCard as farCreditCard
} from '@fortawesome/pro-regular-svg-icons';

import {
    faApple as fabApple,
    faAppStore as fabAppStore,
    faCcMastercard as fabCcMastercard,
    faCcVisa as fabCcVisa,
    faFacebook as fabFacebook,
    faFacebookF as fabFacebookF,
    faFacebookSquare as fabFacebookSquare,
    faGooglePlay as fabGooglePlay,
    faInstagram as fabInstagram,
    faInstagramSquare as fabInstagramSquare,
    faPinterestSquare as fabPinterestSquare,
    faTiktok as fabTiktok,
    faTwitter as fabTwitter,
    faTwitterSquare as fabTwitterSquare,
    faLinkedin as fabLinkedin,
    faYoutube as fabYoutube

} from "@fortawesome/free-brands-svg-icons";

// custom kit
import {
    faCheckIn as fakCheckIn,
    faCheckOut as fakCheckOut,
    faFilter as fakFilter,
} from '@awesome.me/kit-7f7b144cd6/icons/kit/custom';

// Characteristics icons kit
import * as characteristicsIcons from '@awesome.me/kit-eaed03ce48/icons/kit/custom';

library.add(
    falArrowUpFromBracket,
    falCardsBlank,
    falUserGroup,
    falImages,
    falDoorOpen,
    falBlanket,
    falKitchenSet,
    falPlateUtensils,
    falVial,
    falSort,
    fakFilter,
    farConciergeBell,
    farCreditCard,
    fakCheckIn,
    fakCheckOut,
    faCar,
    faFire,
    falBookHeart,
    falRadio,
    fasShield,
    falShield,
    falPaperclip,
    fasPhone,
    falCompass,
    farCompass,
    falCog,
    falCircleExclamation,
    falGiftCard,
    falLeftLong,
    falImagePolaroid,
    falAward,
    falBookmark,
    falHouseHeart,
    falComment,
    falGrid2,
    falTrophyStar,
    falTrophy,
    falCalendarWeek,
    falCalendarXmark,
    falCalendarStar,
    fabApple,
    fabAppStore,
    falCommentAltCheck,
    farLockAlt,
    farLockOpenAlt,
    falCarSide,
    fabCcMastercard,
    fabCcVisa,
    fabFacebook,
    fabFacebookF,
    falHandHoldingHeart,
    fabFacebookSquare,
    fabGooglePlay,
    fabInstagram,
    fabInstagramSquare,
    fabPinterestSquare,
    fabTiktok,
    fabTwitter,
    fabLinkedin,
    fabYoutube,
    fabTwitterSquare,
    farThumbtack,
    farCameraRetro,
    farMessageImage,
    farCalendarAlt,
    farClockRotateLeft,
    falCalendarAlt,
    farArrowLeft,
    farArrowRight,
    farArrowUpRightFromSquare,
    farAward,
    farBell,
    farCalendarWeek,
    farCamera,
    farChevronUp,
    farEllipsisH,
    farFireFlameCurved,
    farGlasses,
    farHandHeart,
    farHeart,
    farHouse,
    farHouseChimneyHeart,
    farImages,
    farInfoCircle,
    farList,
    farLocationDot,
    farMap,
    farMapLocationDot,
    farLocationSmile,
    farMegaphone,
    farMessageDots,
    farMobile,
    farNewspaper,
    farPlus,
    farSearch,
    farShare,
    farSpinnerThird,
    farTag,
    farTrashCan,
    farTrophyStar,
    farUser,
    farChevronDown,
    farVideo,
    farXmark,
    farUserPlus,
    farTimes,
    farBolt,
    farMapPin,
    farEraser,
    fasAsterisk,
    fasPeople,
    fasCalendarHeart,
    fasMapLocationDot,
    fasUserClock,
    fasMoon,
    fasBars,
    fasBed,
    fasCalendarWeek,
    fasCameraRetro,
    fasCheck,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasChevronUp,
    fasCircle,
    fasCircleInfo,
    fasCircleUser,
    fasHeart,
    fasHomeLg,
    fasLock,
    fasMapMarkerAlt,
    fasPaperPlane,
    fasPlusSquare,
    fasQuoteLeft,
    fasRepeat,
    fasSearch,
    fasSignInAlt,
    fasStar,
    fasStarHalfAlt,
    fasTag,
    fasThumbsUp,
    fasTimes,
    fasUserCircle,
    fasBadgeCheck,
    fasPlus,
    fasMinus,
    fasCreditCard,
    falArrowLeft,
    falAtlas,
    falBan,
    falBed,
    falShower,
    falBath,
    falToilet,
    falBell,
    falBuilding,
    falCameraAlt,
    falCampfire,
    falCheck,
    falChevronCircleLeft,
    falChevronCircleRight,
    falChevronLeft,
    falChevronRight,
    falCircle,
    falCircleCheck,
    falClock,
    falCoins,
    falCopy,
    falEnvelope,
    falExclamationTriangle,
    falEye,
    falEyeSlash,
    falFileAlt,
    falFilter,
    falGift,
    falHandHoldingDollar,
    falHeart,
    falHomeAlt,
    falHotTub,
    falHouseFlag,
    falInfoCircle,
    falKey,
    falLanguage,
    falList,
    falLock,
    falMapLocationDot,
    falMapMarkerAlt,
    falMegaphone,
    falMedal,
    falMinus,
    falMobile,
    falMobileAndroidAlt,
    falMoneyBillWave,
    falMoon,
    falPaperPlane,
    falParking,
    falPaw,
    falPen,
    falPhone,
    falPhotoVideo,
    falPiggyBank,
    falPlane,
    falPlus,
    falPresentation,
    falScroll,
    falSearch,
    falShareAlt,
    falShieldCheck,
    falShoppingCart,
    falSignInAlt,
    falSignOutAlt,
    falSortNumericDown,
    falStar,
    falStore,
    falSwimmingPool,
    falSunglasses,
    falTag,
    falTimes,
    falTimesCircle,
    falUser,
    falUserCircle,
    falUserClock,
    falUserPlus,
    falUsers,
    falWheelchair,
    falWifi,
    falArrowRight,
    falArrowRightFromBracket,
    falArrowUpLong,
    falLongArrowDown,
    falAt,
    falBadgeCheck,
    falBars,
    falBarsFilter,
    falBedFront,
    falBellOn,
    falBookSparkles,
    falCamera,
    falChevronDown,
    falChildren,
    falBaby,
    falCoinBlank,
    falCouch,
    falCreditCardFront,
    falExternalLink,
    falFaceSmilingHands,
    falGlasses,
    falHandWave,
    falHashtag,
    falHouse,
    falHouseChimneyHeart,
    falIdCard,
    falLocationDot,
    falLocationSmile,
    falMap,
    falMapPin,
    falMessageDots,
    falMessageSlash,
    falMessageCheck,
    falMessageSms,
    falMountains,
    falNotes,
    falPencil,
    falPeople,
    falChild,
    falQuestionCircle,
    falRoute,
    falShare,
    falSparkles,
    falSprayCanSparkles,
    falThumbsUp,
    falTrash,
    falUserFriends,
    falUserShield,
    falXmark,
    falArrowRightToBracket,
    falBellSlash,
    falPaperPlaneTop,
    falAirConditioner,
    falGrapes,
    falBroom,
    falBinoculars,
    falVanShuttle,
    falBellConcierge,
    falHandHoldingHand,
    falSpa,
    falDumbbell,
    falMessageExclamation,
    falHouseCircleXmark,
    falHeartCircle,
    falHandHeart,
    falMapMarkerQuestion,
    falHandshakeAlt,
    falArrowDown91,
    falCalendarPen,
    falCommentDots,
    falCalendarMinus,
    falArrowDownArrowUp,
    falSlash,
    ...Object.values(characteristicsIcons),
    falPersonSwimming,
    falCards,
    falWineGlass,
    falMartiniGlassCitrus,
    falElevator,
    falUniversalAccess,
    falSliders,
    falArrowDownArrowUp,
    falArrowUpRight,
    falGlobeAfrica,
    falCalendarCheck,
    falCreditCard,
    falCameraViewfinder,
    falLink,
    falCirclePhoneFlip,
    falTags,
    fasBolt,
    fasCircleCheck,
    fasCircleX,
    fasMessageDots,
    falFamily,
    falChevronUp,
    falEggFried,
    falLocationCheck,
    fasUsers,
);

dom.watch({
    autoReplaceSvgRoot: document,
    observeMutationsRoot: document
});
